import { FC } from "react";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./pointsSkeleton.scss";

interface IPointsSkeletonProps {
  compact?: boolean;
  bankRow?: boolean;
}

const PointsSkeleton: FC<PropsWithClasses<IPointsSkeletonProps>> = ({
  classes = {},
  compact = false,
  bankRow = false,
}) => {
  return (
    <span
      className={`${classes.root} ${compact ? classes.compact : ""} ${bankRow ? classes.bankRow : ""}`}
      data-testid="points-skeleton"
      aria-hidden="true"
    />
  );
};

export default classify(defaultClasses)(PointsSkeleton);
